import React, { useState } from 'react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import { MDX } from 'contentbricks'
import { CategoryInterface } from 'types/CategoryInterface'
import { QuestionInterface } from 'types/QuestionInterface'
import { MiniVoting } from '../miniVoting'
import { Articlelink } from './articlelink'
import { Tracking } from 'contentbricks'

const RELATED_ARTICLES = require('../main/relatedArticles.yml')

export const MobileVersion = ({
  questions,
  categories,
  articleID
}: {
  questions: QuestionInterface[]
  categories: CategoryInterface[]
  articleID: string
}) => {
  return (
    <div className='ui accordion'>
      {categories.map((category, i) => {
        const entries = questions.filter(q => {
          if (q.category === category.cat) return q
        })

        return (
          <AccordionGroup
            key={i}
            articleID={articleID}
            entries={entries.sort((a, b) => {
              return a.questionOrder - b.questionOrder
            })}
            category={category}
          />
        )
      })}
    </div>
  )
}
const AccordionGroup = ({
  category,
  entries,
  articleID
}: {
  entries: QuestionInterface[]
  category: CategoryInterface
  articleID: string
}) => {
  return (
    <>
      <Tracking label={'contentCat:' + category.name} />
      <div className={'ui accordion ' + category.cl}>
        <div className='category'>
          <div className='trennerImg'>
            <a id={category.cat} />

            <img
              style={category.mobPos}
              src={require('../../images/trenner_' + category.cat + '.png')}
            />
          </div>
        </div>
        <div className={'name ' + category.textClMobile}>{category.name}</div>

        {entries.map((question, i) => {
          return (
            <AccordionEntry
              key={i}
              articleID={articleID}
              question={question}
              cat={category.cat}
            />
          )
        })}
      </div>
    </>
  )
}

const requireIfReady = (ready: string, fileId: string) => {
  if (ready === 'yes') {
    return require('../../images/icon_' + fileId + '.png')
  }
  return require('../../images/placeholder.png')
}
const AccordionEntry = ({
  question,
  articleID,
  cat
}: {
  question: QuestionInterface
  articleID: string
  cat: string
}) => {
  const [open, openClose] = useState(false)
  function toggle(id: string = '') {
    var dataLayer = window.dataLayer || []
    dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'open_question_' + id
    })
    open ? openClose(false) : openClose(true)
  }
  return (
    <div className={'accordionEntry ' + (open ? 'active' : '')}>
      <a id={question.fileId} />

      <div
        className={open ? 'title active question' : 'title question'}
        onClick={() => {
          toggle(question.category + '_' + question.questionOrder)
        }}
      >
        <div className='questionText'>{question.question}</div>
        <i className={open ? 'close small icon' : 'caret down icon'} />
      </div>
      <div className={open ? 'content active answer' : 'content answer'}>
        {question.icon === 'yes' && (
          <img
            className={'ui centered image'}
            src={requireIfReady(question.iconready || 'no', question.fileId)}
          />
        )}
        <MDX file={require('../_text/' + question.fileId + '.mdx')} />
        <MiniVoting
          articleID={articleID}
          elementId={question.fileId}
          subject={'Fragen zum Schlaf | Feedback zu: ' + question.question}
          inverted={question.category === 'sky' ? true : false}
          scrollUpTarget={cat}
        />
        {RELATED_ARTICLES[question.fileId.replace('q0', 'q')] ? (
          <RELATED
            data={RELATED_ARTICLES[question.fileId.replace('q0', 'q')]}
          />
        ) : (
          <div></div>
        )}
      </div>
    </div>
  )
}

const RELATED = ({ data }) => {
  return (
    <div className='relatedArticles'>
      <small>Artikel zum Thema:</small>
      <br />

      {data.map((d, i) => {
        return (
          <div key={i}>
            <Articlelink
              href={d[1].toString().replace('#mandant#', window.mandant)}
              icon='caret right'
              className='cbLink'
            >
              {d[0]}
            </Articlelink>
          </div>
        )
      })}
    </div>
  )
}
